import { memo, useState } from 'react';
import { useQuery } from 'react-query';
import useAxiosPrivate from 'hooks/useAxiosPrivate';
import Widget from './Widget';
import { useTranslation } from 'react-i18next';
import {
  Button,
  CircularProgress,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import LightBox from 'components/ui/dialogs/LightBox';
import { useLocation } from 'react-router-dom';
import moment from 'moment';
import OfficesCard from './OfficesCard';

function getStatusStyles(status) {
  const statuses = {
    Damda: { text: 'rgb(54, 162, 235)', bg: 'rgb(220, 245, 245)' },
    'Dam Olish Kuni': { text: 'rgb(54, 162, 235)', bg: 'rgb(220, 245, 245)' },
    'Day Off': { text: 'rgb(54, 162, 235)', bg: 'rgb(220, 245, 245)' },

    Kelgan: { text: 'rgb(75, 192, 192)', bg: 'rgb(220, 245, 220)' },
    Arrived: { text: 'rgb(75, 192, 192)', bg: 'rgb(220, 245, 220)' },

    Kechikkan: { text: 'rgb(255, 206, 86)', bg: 'rgb(255, 245, 220)' },
    'Kechikib Kelgan': { text: 'rgb(255, 206, 86)', bg: 'rgb(255, 245, 220)' },
    Late: { text: 'rgb(255, 206, 86)', bg: 'rgb(255, 245, 220)' },

    'Erta Ketgan': { text: 'rgb(153, 102, 255)', bg: 'rgb(235, 225, 255)' },
    'Early Left': { text: 'rgb(153, 102, 255)', bg: 'rgb(235, 225, 255)' },

    Kelmagan: { text: 'rgb(255, 99, 132)', bg: 'rgb(255, 220, 220)' },
    Absent: { text: 'rgb(255, 99, 132)', bg: 'rgb(255, 220, 220)' },
  };
  return statuses?.[status] ?? { text: 'black', bg: '#eee' }; // fallback
}

export default memo(function Offices() {
  const axiosPrivate = useAxiosPrivate();
  const { search } = useLocation();
  const { t } = useTranslation();
  const [openImageModal, setOpenImageModal] = useState(false);
  const [hasError, setHasError] = useState(false);
  const [itemData, setItemData] = useState({});

  const { data, isLoading } = useQuery({
    queryKey: ['/hr/today', search],
    queryFn: async function () {
      const response = await axiosPrivate.get(`/hr/today${search}`);
      return response.data.data;
    },
    enabled: !hasError,
    onError: (error) => {
      setHasError(true);
    },
    retry: false,
  });

  const offices = data?.stats ? Object.keys(data?.stats) : [];

  return (
    <div className='h-full relative'>
      {isLoading && (
        <div className='flex items-center justify-center absolute inset-0 z-10 bg-[rgba(255,255,255,0.8)] mb-2'>
          <CircularProgress />
        </div>
      )}

      {offices?.map((office) => (
        <OfficesCard
          key={office}
          data={data}
          office={office}
          setOpenImageModal={setOpenImageModal}
          setItemData={setItemData}
        />
      ))}
      {openImageModal && itemData?.image ? (
        // yet-another-react-lightbox
        <LightBox
          isOpen={openImageModal}
          style={{ zIndex: 1040 }}
          captions={[`${itemData?.name} - ${itemData?.time}`]}
          titles={[`${itemData?.name} - ${itemData?.time}`]}
          images={[`${itemData?.image}`]}
          photoIndex={0}
          setIsOpen={() => {
            setOpenImageModal(false);
            setItemData({});
          }}
        />
      ) : null}
    </div>
  );
});
